import { Box } from '@material-ui/core';
import React from 'react';

import Loader from '../../../../components/LoaderSplash/Loader.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import LandingAnswer from '../../Landing/Answer';
import { useLoginForm } from '../hooks';
import LoginFormAnswer from './LoginForm';

const LoginPatagonia = () => {
  const { isOpenDialog, closeDialog, dialog, handleSubmit, isLoading } =
    useLoginForm();

  if (isLoading) {
    return (
      <Box display="block">
        <Loader action="Iniciando sesión" />
      </Box>
    );
  }

  return (
    <>
      <SharedDialog
        open={isOpenDialog}
        title={dialog?.title}
        content={dialog?.content}
        actions={dialog?.action}
        onClose={closeDialog}
      />
      <LandingAnswer>
        <LoginFormAnswer handleSubmit={handleSubmit} />
      </LandingAnswer>
    </>
  );
};

LoginPatagonia.displayName = 'LoginPatagonia';

export default LoginPatagonia;
